import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ordenesApi } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { formatDate, formatDateTime } from '../utils/dateHelpers';

const OrdenDetalle = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const [orden, setOrden] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showEntregaModal, setShowEntregaModal] = useState(false);
  const [showPrintMenu, setShowPrintMenu] = useState(false);
  const [entregando, setEntregando] = useState(false);
  const [entregaForm, setEntregaForm] = useState({
    tipo_pago: 'Efectivo',
    monto_pago: '',
    referencia_pago: '',
    notas_entrega: ''
  });
  const printRef = useRef();
  const printTicketRef = useRef();

  useEffect(() => {
    loadOrden();
  }, [id]);

  const loadOrden = async () => {
    try {
      const data = await ordenesApi.getById(id);
      setOrden(data);
    } catch (err) {
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = (formato = 'media-carta') => {
    setShowPrintMenu(false);
    const printContent = formato === 'ticket-80mm' ? printTicketRef.current : printRef.current;

    const printWindow = window.open('about:blank', '_blank', 'width=800,height=600');
    if (!printWindow) {
      alert('Por favor habilite las ventanas emergentes para imprimir');
      return;
    }

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8">
          <title>Orden #${orden.numero_orden}</title>
        </head>
        <body>
          ${printContent.innerHTML}
          <script>
            window.addEventListener('load', function() {
              setTimeout(function() {
                window.print();
              }, 500);
            });
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  const handlePrintRecibo = () => {
    if (!orden || parseFloat(orden.anticipo) <= 0) {
      alert('Esta orden no tiene anticipo registrado');
      return;
    }

    const printWindow = window.open('about:blank', '_blank', 'width=400,height=600');
    if (!printWindow) {
      alert('Por favor habilite las ventanas emergentes para imprimir');
      return;
    }

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8">
          <title>Recibo Anticipo - Orden #${orden.numero_orden}</title>
          <style>
            /* ========================================
               CSS OPTIMIZADO PARA IMPRESORA TÉRMICA
               POS-80 / 80mm Thermal Printer
               ======================================== */

            @media print {
              @page {
                size: 72mm auto;
                margin: 0 !important;
                padding: 0 !important;
              }

              * {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
                color-adjust: exact !important;
              }

              body {
                font-family: Arial, Helvetica, 'Liberation Sans', sans-serif !important;
                font-size: 12px !important;
                font-weight: 600 !important;
                line-height: 1.3 !important;
                margin: 0 !important;
                padding: 0 !important;
                width: 72mm !important;
                max-width: 72mm !important;
                color: #000 !important;
                background: #fff !important;
                text-shadow: 0.3px 0 0 #000, -0.3px 0 0 #000 !important;
              }

              .recibo-container {
                width: 72mm !important;
                max-width: 72mm !important;
                padding: 2mm !important;
                box-sizing: border-box !important;
              }

              .recibo-header {
                text-align: center;
                border-bottom: 2px solid #000;
                padding-bottom: 3mm;
                margin-bottom: 3mm;
              }

              .recibo-logo {
                font-size: 18px !important;
                font-weight: 900 !important;
                margin-bottom: 2px;
                letter-spacing: 1px;
                text-shadow: 0.5px 0 0 #000, -0.5px 0 0 #000, 0 0.5px 0 #000 !important;
              }

              .recibo-subtitle {
                font-size: 12px !important;
                font-weight: 700 !important;
                margin-bottom: 2px;
              }

              .recibo-contact {
                font-size: 11px !important;
                font-weight: 600 !important;
              }

              .recibo-tipo {
                text-align: center;
                font-size: 14px !important;
                font-weight: 900 !important;
                margin: 3mm 0;
                padding: 2mm;
                border: 2px solid #000;
                text-shadow: 0.4px 0 0 #000 !important;
              }

              .recibo-orden {
                text-align: center;
                font-size: 13px !important;
                font-weight: 800 !important;
                margin-bottom: 3mm;
              }

              .recibo-section {
                margin-bottom: 3mm;
                border-bottom: 1px dashed #000;
                padding-bottom: 2mm;
              }

              .recibo-row {
                display: flex;
                justify-content: space-between;
                font-size: 11px !important;
                font-weight: 600 !important;
                margin-bottom: 1mm;
                line-height: 1.4;
              }

              .recibo-label {
                font-weight: 800 !important;
                text-shadow: 0.3px 0 0 #000 !important;
              }

              .recibo-monto {
                border: 3px solid #000;
                padding: 4mm;
                margin: 3mm 0;
                text-align: center;
              }

              .recibo-monto-label {
                font-size: 11px !important;
                font-weight: 800 !important;
                margin-bottom: 2mm;
              }

              .recibo-monto-valor {
                font-size: 24px !important;
                font-weight: 900 !important;
                text-shadow: 0.6px 0 0 #000, -0.6px 0 0 #000, 0 0.6px 0 #000 !important;
              }

              .recibo-totales {
                border-top: 2px solid #000;
                border-bottom: 2px solid #000;
                padding: 3mm 0;
                margin: 3mm 0;
              }

              .recibo-total-row {
                display: flex;
                justify-content: space-between;
                font-size: 11px !important;
                font-weight: 600 !important;
                margin-bottom: 1mm;
              }

              .recibo-total-row.saldo {
                font-size: 14px !important;
                font-weight: 900 !important;
                margin-top: 2mm;
                padding-top: 2mm;
                border-top: 2px solid #000;
                text-shadow: 0.5px 0 0 #000, -0.5px 0 0 #000 !important;
              }

              .recibo-footer {
                text-align: center;
                font-size: 10px !important;
                font-weight: 600 !important;
                margin-top: 3mm;
                padding-top: 3mm;
                border-top: 1px solid #000;
              }

              .recibo-footer p {
                margin: 1mm 0 !important;
                line-height: 1.4;
              }

              .recibo-corte {
                text-align: center;
                margin-top: 5mm;
                padding-top: 3mm;
                border-top: 2px dashed #000;
                font-size: 10px !important;
                font-weight: 700 !important;
              }
            }
          </style>
        </head>
        <body>
          <div class="recibo-container">
            <div class="recibo-header">
              <div class="recibo-logo">INTERSECOM</div>
              <div class="recibo-subtitle">DE TODO EN COMPUTACIÓN</div>
              <div class="recibo-subtitle">- DEPTO. TÉCNICO -</div>
              <div class="recibo-contact">15 Av. 1-340 Zona 5, San Marcos</div>
              <div class="recibo-contact">Tel: 7760-3991 / 7725-4830</div>
            </div>

            <div class="recibo-tipo">RECIBO DE ANTICIPO</div>
            <div class="recibo-orden">ORDEN N° ${orden.numero_orden}</div>

            <div class="recibo-section">
              <div class="recibo-row">
                <span class="recibo-label">Cliente:</span>
                <span>${orden.nombre_cliente}</span>
              </div>
              <div class="recibo-row">
                <span class="recibo-label">Fecha:</span>
                <span>${formatDate(orden.fecha_anticipo || orden.fecha_recepcion)}</span>
              </div>
              <div class="recibo-row">
                <span class="recibo-label">Servicio:</span>
                <span>${orden.tipo_servicio}</span>
              </div>
              ${orden.equipo1_descripcion ? `
              <div class="recibo-row">
                <span class="recibo-label">Equipo:</span>
                <span>${orden.equipo1_descripcion}</span>
              </div>
              ` : ''}
            </div>

            <div class="recibo-monto">
              <div class="recibo-monto-label">ANTICIPO RECIBIDO</div>
              <div class="recibo-monto-valor">${formatMoney(orden.anticipo)}</div>
            </div>

            <div class="recibo-totales">
              <div class="recibo-total-row">
                <span>Total Orden:</span>
                <span>${formatMoney(orden.valor_total)}</span>
              </div>
              <div class="recibo-total-row">
                <span>Anticipo:</span>
                <span>- ${formatMoney(orden.anticipo)}</span>
              </div>
              <div class="recibo-total-row saldo">
                <span>SALDO:</span>
                <span>${formatMoney(orden.saldo)}</span>
              </div>
            </div>

            <div class="recibo-row">
              <span class="recibo-label">Atendido por:</span>
              <span>${orden.nombre_tecnico || 'N/A'}</span>
            </div>
            <div class="recibo-row">
              <span class="recibo-label">Tienda:</span>
              <span>${orden.nombre_tienda || 'INTERSECOM'}</span>
            </div>

            <div class="recibo-footer">
              <p><strong>Este recibo es válido como</strong></p>
              <p><strong>comprobante de pago de anticipo.</strong></p>
              <p style="margin-top: 2mm;">Gracias por su preferencia</p>
            </div>

            <div class="recibo-corte">
              - - - - - - - - - - - - - - - - - - -
            </div>
          </div>
          <script>
            window.addEventListener('load', function() {
              setTimeout(function() {
                window.print();
              }, 500);
            });
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  const formatMoney = (amount) => {
    return `Q${parseFloat(amount || 0).toLocaleString('es-GT', { minimumFractionDigits: 2 })}`;
  };

  const openEntregaModal = () => {
    setEntregaForm({
      tipo_pago: 'Efectivo',
      monto_pago: orden.saldo || 0,
      referencia_pago: '',
      notas_entrega: ''
    });
    setShowEntregaModal(true);
  };

  const handleEntrega = async (e) => {
    e.preventDefault();

    if (['Transferencia', 'Tarjeta'].includes(entregaForm.tipo_pago) && !entregaForm.referencia_pago.trim()) {
      alert('Debe ingresar el número de referencia/transacción');
      return;
    }

    setEntregando(true);
    try {
      await ordenesApi.entregar({
        id: orden.id,
        tipo_pago: entregaForm.tipo_pago,
        monto_pago: parseFloat(entregaForm.monto_pago) || 0,
        referencia_pago: entregaForm.referencia_pago,
        notas_entrega: entregaForm.notas_entrega,
        entregado_por: user?.id
      });

      setShowEntregaModal(false);
      loadOrden(); // Recargar la orden
      alert('Orden entregada exitosamente');
    } catch (err) {
      console.error('Error:', err);
      alert('Error al entregar la orden: ' + (err.response?.data?.error || err.message));
    } finally {
      setEntregando(false);
    }
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!orden) {
    return (
      <div className="empty-state">
        <h3>Orden no encontrada</h3>
        <Link to="/ordenes" className="btn btn-primary" style={{ marginTop: '16px' }}>
          Volver a Órdenes
        </Link>
      </div>
    );
  }

  // Componente de boleta reutilizable para imprimir
  const BoletaRecepcion = ({ copia }) => (
    <div className="boleta-recepcion">
      <div className="boleta-header">
        <div className="boleta-order-number">
          <small>ORDEN PARA REPARACIÓN</small>
          <span>N° {orden.numero_orden}</span>
        </div>
        <div className="boleta-empresa">
          <h1>INTERSECOM DE TODO EN COMPUTACIÓN</h1>
          <p className="boleta-depto">- DEPARTAMENTO TÉCNICO -</p>
          <p>15 Avenida 1-340 Zona 5 San Marcos</p>
          <p>Tels. 7760 3991 - 7725 4830 - 3339 1099</p>
        </div>
        <div className="boleta-copia">
          {copia}
        </div>
      </div>

      <div className="boleta-fecha">
        <strong>Fecha:</strong> {formatDate(orden.fecha_recepcion)}
      </div>

      <div className="boleta-cliente">
        <div className="boleta-row">
          <span className="boleta-label">Recibí de:</span>
          <span className="boleta-value">{orden.nombre_cliente}</span>
          <span className="boleta-label">Tel:</span>
          <span className="boleta-value">{orden.telefono_cliente || '-'}</span>
        </div>
      </div>

      {orden.equipo1_descripcion && (
        <div className="boleta-equipo">
          <div className="boleta-row">
            <span className="boleta-label">Equipo 1:</span>
            <span className="boleta-value">{orden.equipo1_descripcion} {orden.equipo1_marca ? `- ${orden.equipo1_marca}` : ''}</span>
          </div>
          <div className="boleta-row">
            <span className="boleta-label">Serie:</span>
            <span className="boleta-value">{orden.equipo1_numero_serie || '-'}</span>
            <span className="boleta-label">Acceso:</span>
            <span className="boleta-value">{orden.equipo1_datos_acceso || '-'}</span>
          </div>
          <div className="boleta-row">
            <span className="boleta-label">Accesorios:</span>
            <span className="boleta-value">{orden.equipo1_accesorios || 'Ninguno'}</span>
          </div>
          <div className="boleta-row">
            <span className="boleta-label">Falla:</span>
            <span className="boleta-value boleta-falla">{orden.equipo1_falla || '-'}</span>
          </div>
        </div>
      )}

      {orden.equipo2_descripcion && (
        <div className="boleta-equipo">
          <div className="boleta-row">
            <span className="boleta-label">Equipo 2:</span>
            <span className="boleta-value">{orden.equipo2_descripcion} {orden.equipo2_marca ? `- ${orden.equipo2_marca}` : ''}</span>
          </div>
          <div className="boleta-row">
            <span className="boleta-label">Serie:</span>
            <span className="boleta-value">{orden.equipo2_numero_serie || '-'}</span>
            <span className="boleta-label">Acceso:</span>
            <span className="boleta-value">{orden.equipo2_datos_acceso || '-'}</span>
          </div>
          <div className="boleta-row">
            <span className="boleta-label">Accesorios:</span>
            <span className="boleta-value">{orden.equipo2_accesorios || 'Ninguno'}</span>
          </div>
          <div className="boleta-row">
            <span className="boleta-label">Falla:</span>
            <span className="boleta-value boleta-falla">{orden.equipo2_falla || '-'}</span>
          </div>
        </div>
      )}

      {orden.equipo3_descripcion && (
        <div className="boleta-equipo">
          <div className="boleta-row">
            <span className="boleta-label">Equipo 3:</span>
            <span className="boleta-value">{orden.equipo3_descripcion} {orden.equipo3_marca ? `- ${orden.equipo3_marca}` : ''}</span>
          </div>
          <div className="boleta-row">
            <span className="boleta-label">Serie:</span>
            <span className="boleta-value">{orden.equipo3_numero_serie || '-'}</span>
            <span className="boleta-label">Acceso:</span>
            <span className="boleta-value">{orden.equipo3_datos_acceso || '-'}</span>
          </div>
          <div className="boleta-row">
            <span className="boleta-label">Accesorios:</span>
            <span className="boleta-value">{orden.equipo3_accesorios || 'Ninguno'}</span>
          </div>
          <div className="boleta-row">
            <span className="boleta-label">Falla:</span>
            <span className="boleta-value boleta-falla">{orden.equipo3_falla || '-'}</span>
          </div>
        </div>
      )}

      {orden.observaciones && (
        <div className="boleta-observaciones">
          <span className="boleta-label">Observaciones:</span>
          <span className="boleta-value">{orden.observaciones}</span>
        </div>
      )}

      <div className="boleta-firmas">
        <div className="boleta-firma-box">
          <div className="boleta-firma-label">RECIBIDO POR</div>
          <div className="boleta-firma-value">{orden.nombre_tecnico || ''}</div>
        </div>
        {orden.nombre_tecnico_asignado && (
          <div className="boleta-firma-box">
            <div className="boleta-firma-label">TECNICO</div>
            <div className="boleta-firma-value" style={{ fontWeight: 'bold', color: '#0369a1' }}>{orden.nombre_tecnico_asignado}</div>
          </div>
        )}
        <div className="boleta-firma-box">
          <div className="boleta-firma-label">ANTICIPO</div>
          <div className="boleta-firma-value boleta-anticipo">{formatMoney(orden.anticipo)}</div>
        </div>
        <div className="boleta-firma-box">
          <div className="boleta-firma-label">TIENDA</div>
          <div className="boleta-firma-value">{orden.nombre_tienda || ''}</div>
        </div>
        <div className="boleta-firma-box boleta-firma-cliente">
          <div className="boleta-firma-label">FIRMA CLIENTE</div>
          <div className="boleta-firma-linea"></div>
        </div>
      </div>

      {orden.status === 'entregada' && parseFloat(orden.saldo) === 0 && (
        <div className="boleta-pagado" style={{
          marginTop: '10px',
          padding: '8px',
          background: '#f0fdf4',
          border: '2px solid #16a34a',
          textAlign: 'center',
          borderRadius: '4px'
        }}>
          <div style={{ fontWeight: 'bold', fontSize: '10px', color: '#166534' }}>✓ PAGADO COMPLETAMENTE</div>
          <div style={{ fontSize: '9px', color: '#166534' }}>
            {orden.tipo_pago}
            {orden.monto_pago_final && ` - ${formatMoney(orden.monto_pago_final)}`}
            {orden.fecha_pago_final && ` - ${formatDate(orden.fecha_pago_final)}`}
          </div>
          {orden.referencia_pago && (
            <div style={{ fontSize: '8px', color: '#166534' }}>Ref: {orden.referencia_pago}</div>
          )}
        </div>
      )}

      <div className="boleta-footer">
        <p><strong>Importante:</strong> La empresa no se hace responsable a cubrir la garantía de daños causados por el mal uso del equipo o inestabilidad de corriente eléctrica. La empresa no se hace responsable del equipo si en término de 30 días no es recogido el mismo.</p>
      </div>
    </div>
  );

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Orden #{orden.numero_orden}</h1>
          <p className="page-subtitle">
            Recibida el {formatDate(orden.fecha_recepcion)}
            <span className={`status-badge status-${orden.status}`} style={{ marginLeft: '12px' }}>
              {orden.status}
            </span>
          </p>
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <div style={{ position: 'relative' }}>
            <button onClick={() => setShowPrintMenu(!showPrintMenu)} className="btn btn-secondary">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                <polyline points="6 9 6 2 18 2 18 9"/>
                <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
                <rect x="6" y="14" width="12" height="8"/>
              </svg>
              Imprimir
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16" style={{ marginLeft: '4px' }}>
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>
            {showPrintMenu && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                marginTop: '4px',
                background: 'white',
                border: '1px solid #ddd',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                zIndex: 1000,
                minWidth: '200px',
                overflow: 'hidden'
              }}>
                <button
                  onClick={() => handlePrint('media-carta')}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    width: '100%',
                    padding: '12px 16px',
                    border: 'none',
                    background: 'none',
                    cursor: 'pointer',
                    textAlign: 'left',
                    fontSize: '14px'
                  }}
                  onMouseOver={(e) => e.target.style.background = '#f5f5f5'}
                  onMouseOut={(e) => e.target.style.background = 'none'}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                    <rect x="3" y="3" width="18" height="18" rx="2"/>
                    <line x1="3" y1="12" x2="21" y2="12"/>
                  </svg>
                  <div>
                    <div style={{ fontWeight: '500' }}>Media Carta</div>
                    <div style={{ fontSize: '11px', color: '#666' }}>2 boletas por hoja</div>
                  </div>
                </button>
                <button
                  onClick={() => handlePrint('ticket-80mm')}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    width: '100%',
                    padding: '12px 16px',
                    border: 'none',
                    background: 'none',
                    cursor: 'pointer',
                    textAlign: 'left',
                    fontSize: '14px',
                    borderTop: '1px solid #eee'
                  }}
                  onMouseOver={(e) => e.target.style.background = '#f5f5f5'}
                  onMouseOut={(e) => e.target.style.background = 'none'}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                    <rect x="7" y="2" width="10" height="20" rx="1"/>
                    <line x1="9" y1="6" x2="15" y2="6"/>
                    <line x1="9" y1="10" x2="15" y2="10"/>
                    <line x1="9" y1="14" x2="13" y2="14"/>
                  </svg>
                  <div>
                    <div style={{ fontWeight: '500' }}>Ticket 80mm</div>
                    <div style={{ fontSize: '11px', color: '#666' }}>Impresora térmica</div>
                  </div>
                </button>
                {parseFloat(orden?.anticipo) > 0 && (
                  <button
                    onClick={handlePrintRecibo}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      width: '100%',
                      padding: '12px 16px',
                      border: 'none',
                      background: 'none',
                      cursor: 'pointer',
                      textAlign: 'left',
                      fontSize: '14px',
                      borderTop: '1px solid #eee'
                    }}
                    onMouseOver={(e) => e.target.style.background = '#f5f5f5'}
                    onMouseOut={(e) => e.target.style.background = 'none'}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                      <path d="M9 14l2 2 4-4m-1-7V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1M5 10h14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1z"/>
                    </svg>
                    <div>
                      <div style={{ fontWeight: '500' }}>Recibo de Anticipo</div>
                      <div style={{ fontSize: '11px', color: '#666' }}>{formatMoney(orden?.anticipo)}</div>
                    </div>
                  </button>
                )}
              </div>
            )}
          </div>
          {orden.status !== 'entregada' && (
            <button onClick={openEntregaModal} className="btn btn-success" style={{ background: '#38a169' }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
                <path d="M9 11l3 3L22 4"/>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
              </svg>
              Entregar
            </button>
          )}
          <Link to={`/ordenes/editar/${orden.id}`} className="btn btn-primary">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
            Editar
          </Link>
        </div>
      </div>

      {/* Vista Normal */}
      <div className="card">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px' }}>
          {/* Cliente */}
          <div>
            <h3 style={{ fontSize: '14px', color: 'var(--text-light)', marginBottom: '12px', textTransform: 'uppercase' }}>
              Cliente
            </h3>
            <p style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>{orden.nombre_cliente}</p>
            <p style={{ color: 'var(--text-light)' }}>{orden.telefono_cliente || 'Sin teléfono'}</p>
            <p style={{ color: 'var(--text-light)' }}>{orden.correo_cliente || 'Sin correo'}</p>
          </div>

          {/* Servicio */}
          <div>
            <h3 style={{ fontSize: '14px', color: 'var(--text-light)', marginBottom: '12px', textTransform: 'uppercase' }}>
              Servicio
            </h3>
            <p style={{ marginBottom: '8px' }}><strong>Tipo:</strong> {orden.tipo_servicio}</p>
            <p style={{ marginBottom: '8px' }}><strong>Recibido por:</strong> {orden.nombre_tecnico || '-'}</p>
            {orden.nombre_tecnico_asignado && (
              <p style={{ marginBottom: '8px', background: '#e0f2fe', padding: '8px 12px', borderRadius: '6px', border: '1px solid #7dd3fc' }}>
                <strong>Tecnico Encargado:</strong> <span style={{ color: '#0369a1', fontWeight: '600' }}>{orden.nombre_tecnico_asignado}</span>
              </p>
            )}
            <p><strong>Tienda:</strong> {orden.nombre_tienda || '-'}</p>
          </div>

          {/* Totales */}
          <div style={{ background: '#f8fafc', padding: '20px', borderRadius: '8px' }}>
            <h3 style={{ fontSize: '14px', color: 'var(--text-light)', marginBottom: '12px', textTransform: 'uppercase' }}>
              Total al Cliente
            </h3>
            {orden.servicios && orden.servicios.length > 0 && (
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span>Servicios:</span>
                <span>{formatMoney(orden.servicios.reduce((sum, s) => sum + parseFloat(s.subtotal || 0), 0))}</span>
              </div>
            )}
            {orden.mercaderias && orden.mercaderias.length > 0 && (
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span>Mercadería:</span>
                <span>{formatMoney(orden.mercaderias.reduce((sum, m) => sum + parseFloat(m.subtotal || 0), 0))}</span>
              </div>
            )}
            {orden.repuestos && orden.repuestos.length > 0 && (
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span>Repuestos:</span>
                <span>{formatMoney(orden.repuestos.reduce((sum, r) => sum + parseFloat(r.subtotal_venta || 0), 0))}</span>
              </div>
            )}
            {parseFloat(orden.precio_mercaderia) > 0 && (
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '12px', color: 'var(--text-light)' }}>
                <span>Mercadería (legacy):</span>
                <span>{formatMoney(orden.precio_mercaderia)}</span>
              </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span>Trabajo:</span>
              <span>{formatMoney(orden.costo_trabajo)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', paddingTop: '8px', borderTop: '1px solid var(--border-color)' }}>
              <strong>TOTAL:</strong>
              <strong style={{ fontSize: '18px' }}>{formatMoney(orden.valor_total)}</strong>
            </div>

            {/* Sección de Pagos */}
            <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '2px solid var(--border-color)' }}>
              <h4 style={{ fontSize: '13px', fontWeight: '600', marginBottom: '8px', color: 'var(--text-light)' }}>PAGOS</h4>

              {parseFloat(orden.anticipo) > 0 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', paddingLeft: '8px' }}>
                  <span style={{ fontSize: '13px' }}>
                    Anticipo
                    {orden.fecha_anticipo && <span style={{ color: 'var(--text-light)', fontSize: '11px' }}> ({formatDate(orden.fecha_anticipo)})</span>}
                  </span>
                  <span style={{ fontWeight: '500' }}>- {formatMoney(orden.anticipo)}</span>
                </div>
              )}

              {orden.status === 'entregada' && parseFloat(orden.monto_pago_final) > 0 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', paddingLeft: '8px' }}>
                  <span style={{ fontSize: '13px' }}>
                    Pago Final - {orden.tipo_pago}
                    {orden.fecha_pago_final && <span style={{ color: 'var(--text-light)', fontSize: '11px' }}> ({formatDate(orden.fecha_pago_final)})</span>}
                    {orden.referencia_pago && (
                      <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>Ref: {orden.referencia_pago}</div>
                    )}
                  </span>
                  <span style={{ fontWeight: '500' }}>- {formatMoney(orden.monto_pago_final)}</span>
                </div>
              )}

              {/* Total Pagado vs Saldo */}
              {orden.status === 'entregada' && parseFloat(orden.saldo) === 0 ? (
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: '8px',
                  borderTop: '1px solid var(--border-color)',
                  background: '#f0fdf4',
                  padding: '12px',
                  borderRadius: '6px',
                  marginTop: '8px'
                }}>
                  <strong style={{ color: '#166534' }}>✓ PAGADO COMPLETAMENTE</strong>
                  <strong style={{ fontSize: '18px', color: '#16a34a' }}>
                    {formatMoney(parseFloat(orden.anticipo) + parseFloat(orden.monto_pago_final || 0))}
                  </strong>
                </div>
              ) : (
                <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '8px', borderTop: '1px solid var(--border-color)' }}>
                  <strong>SALDO PENDIENTE:</strong>
                  <strong style={{ fontSize: '18px', color: parseFloat(orden.saldo) > 0 ? 'var(--danger-color)' : 'var(--success-color)' }}>
                    {formatMoney(orden.saldo)}
                  </strong>
                </div>
              )}

              {orden.notas_entrega && (
                <div style={{
                  marginTop: '12px',
                  padding: '10px',
                  background: '#fef9c3',
                  borderRadius: '6px',
                  fontSize: '12px'
                }}>
                  <strong>Notas de Entrega:</strong> {orden.notas_entrega}
                </div>
              )}
            </div>
            {(parseFloat(orden.costo_repuesto) > 0 || (orden.repuestos && orden.repuestos.length > 0)) && (
              <div style={{ marginTop: '12px', paddingTop: '8px', borderTop: '1px dashed var(--border-color)', fontSize: '12px', color: 'var(--text-light)' }}>
                {parseFloat(orden.costo_repuesto) > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Costo repuesto legacy (interno):</span>
                    <span>{formatMoney(orden.costo_repuesto)}</span>
                  </div>
                )}
                {orden.repuestos && orden.repuestos.length > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Costo repuestos compra (interno):</span>
                    <span>{formatMoney(orden.repuestos.reduce((sum, r) => sum + parseFloat(r.subtotal_compra || 0), 0))}</span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Equipos */}
      {orden.equipo1_descripcion && (
        <div className="card">
          <h3 className="card-title" style={{ marginBottom: '16px' }}>Equipo 1</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
            <div>
              <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Descripción</span>
              <p style={{ fontWeight: '500' }}>{orden.equipo1_descripcion}</p>
            </div>
            <div>
              <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Marca</span>
              <p style={{ fontWeight: '500' }}>{orden.equipo1_marca || '-'}</p>
            </div>
            <div>
              <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Número de Serie</span>
              <p style={{ fontWeight: '500' }}>{orden.equipo1_numero_serie || '-'}</p>
            </div>
            <div>
              <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Accesorios</span>
              <p style={{ fontWeight: '500' }}>{orden.equipo1_accesorios || '-'}</p>
            </div>
            <div>
              <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Datos de Acceso</span>
              <p style={{ fontWeight: '500' }}>{orden.equipo1_datos_acceso || '-'}</p>
            </div>
          </div>
          <div style={{ marginTop: '16px' }}>
            <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Falla</span>
            <p style={{ fontWeight: '500', whiteSpace: 'pre-wrap' }}>{orden.equipo1_falla || '-'}</p>
          </div>
        </div>
      )}

      {orden.equipo2_descripcion && (
        <div className="card">
          <h3 className="card-title" style={{ marginBottom: '16px' }}>Equipo 2</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
            <div>
              <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Descripción</span>
              <p style={{ fontWeight: '500' }}>{orden.equipo2_descripcion}</p>
            </div>
            <div>
              <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Marca</span>
              <p style={{ fontWeight: '500' }}>{orden.equipo2_marca || '-'}</p>
            </div>
            <div>
              <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Número de Serie</span>
              <p style={{ fontWeight: '500' }}>{orden.equipo2_numero_serie || '-'}</p>
            </div>
            <div>
              <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Accesorios</span>
              <p style={{ fontWeight: '500' }}>{orden.equipo2_accesorios || '-'}</p>
            </div>
          </div>
          <div style={{ marginTop: '16px' }}>
            <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Falla</span>
            <p style={{ fontWeight: '500', whiteSpace: 'pre-wrap' }}>{orden.equipo2_falla || '-'}</p>
          </div>
        </div>
      )}

      {orden.equipo3_descripcion && (
        <div className="card">
          <h3 className="card-title" style={{ marginBottom: '16px' }}>Equipo 3</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
            <div>
              <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Descripción</span>
              <p style={{ fontWeight: '500' }}>{orden.equipo3_descripcion}</p>
            </div>
            <div>
              <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Marca</span>
              <p style={{ fontWeight: '500' }}>{orden.equipo3_marca || '-'}</p>
            </div>
            <div>
              <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Número de Serie</span>
              <p style={{ fontWeight: '500' }}>{orden.equipo3_numero_serie || '-'}</p>
            </div>
            <div>
              <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Accesorios</span>
              <p style={{ fontWeight: '500' }}>{orden.equipo3_accesorios || '-'}</p>
            </div>
          </div>
          <div style={{ marginTop: '16px' }}>
            <span style={{ color: 'var(--text-light)', fontSize: '13px' }}>Falla</span>
            <p style={{ fontWeight: '500', whiteSpace: 'pre-wrap' }}>{orden.equipo3_falla || '-'}</p>
          </div>
        </div>
      )}

      {/* Trabajo y Observaciones */}
      <div className="card">
        <h3 className="card-title" style={{ marginBottom: '16px' }}>Detalle del Trabajo</h3>
        <p style={{ whiteSpace: 'pre-wrap' }}>{orden.detalle_trabajo || 'Sin detalle'}</p>

        {orden.condicion_fisica && (
          <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid var(--border-color)' }}>
            <h4 style={{ marginBottom: '8px' }}>Condición Física del Equipo (al recibir)</h4>
            <p style={{ whiteSpace: 'pre-wrap' }}>{orden.condicion_fisica}</p>
          </div>
        )}

        {orden.observaciones && (
          <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid var(--border-color)' }}>
            <h4 style={{ marginBottom: '8px' }}>Observaciones</h4>
            <p style={{ whiteSpace: 'pre-wrap' }}>{orden.observaciones}</p>
          </div>
        )}
      </div>

      {/* Servicios */}
      {orden.servicios && orden.servicios.length > 0 && (
        <div className="card">
          <h3 className="card-title" style={{ marginBottom: '16px' }}>Servicios Prestados</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid var(--border-color)', textAlign: 'left' }}>
                <th style={{ padding: '8px' }}>Descripción</th>
                <th style={{ padding: '8px', width: '100px', textAlign: 'center' }}>Cantidad</th>
                <th style={{ padding: '8px', width: '120px', textAlign: 'right' }}>Precio Unit.</th>
                <th style={{ padding: '8px', width: '120px', textAlign: 'right' }}>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {orden.servicios.map((servicio, index) => (
                <tr key={index} style={{ borderBottom: '1px solid var(--border-color)' }}>
                  <td style={{ padding: '8px' }}>
                    {servicio.descripcion}
                    {servicio.notas && <div style={{ fontSize: '12px', color: 'var(--text-light)' }}>{servicio.notas}</div>}
                  </td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>{parseFloat(servicio.cantidad).toFixed(2)}</td>
                  <td style={{ padding: '8px', textAlign: 'right' }}>{formatMoney(servicio.precio_unitario)}</td>
                  <td style={{ padding: '8px', textAlign: 'right', fontWeight: '600' }}>{formatMoney(servicio.subtotal)}</td>
                </tr>
              ))}
              <tr>
                <td colSpan="3" style={{ padding: '8px', textAlign: 'right', fontWeight: '600' }}>Total Servicios:</td>
                <td style={{ padding: '8px', textAlign: 'right', fontWeight: '600', fontSize: '16px' }}>
                  {formatMoney(orden.servicios.reduce((sum, s) => sum + parseFloat(s.subtotal || 0), 0))}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Mercaderías */}
      {orden.mercaderias && orden.mercaderias.length > 0 && (
        <div className="card">
          <h3 className="card-title" style={{ marginBottom: '16px' }}>Mercadería</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid var(--border-color)', textAlign: 'left' }}>
                <th style={{ padding: '8px' }}>Descripción</th>
                <th style={{ padding: '8px', width: '100px', textAlign: 'center' }}>Cantidad</th>
                <th style={{ padding: '8px', width: '120px', textAlign: 'right' }}>Precio Unit.</th>
                <th style={{ padding: '8px', width: '120px', textAlign: 'right' }}>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {orden.mercaderias.map((mercaderia, index) => (
                <tr key={index} style={{ borderBottom: '1px solid var(--border-color)' }}>
                  <td style={{ padding: '8px' }}>
                    {mercaderia.descripcion}
                    {mercaderia.notas && <div style={{ fontSize: '12px', color: 'var(--text-light)' }}>{mercaderia.notas}</div>}
                  </td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>{parseFloat(mercaderia.cantidad).toFixed(2)}</td>
                  <td style={{ padding: '8px', textAlign: 'right' }}>{formatMoney(mercaderia.precio_unitario)}</td>
                  <td style={{ padding: '8px', textAlign: 'right', fontWeight: '600' }}>{formatMoney(mercaderia.subtotal)}</td>
                </tr>
              ))}
              <tr>
                <td colSpan="3" style={{ padding: '8px', textAlign: 'right', fontWeight: '600' }}>Total Mercadería:</td>
                <td style={{ padding: '8px', textAlign: 'right', fontWeight: '600', fontSize: '16px' }}>
                  {formatMoney(orden.mercaderias.reduce((sum, m) => sum + parseFloat(m.subtotal || 0), 0))}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Repuestos */}
      {orden.repuestos && orden.repuestos.length > 0 && (
        <div className="card">
          <h3 className="card-title" style={{ marginBottom: '16px' }}>Repuestos</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid var(--border-color)', textAlign: 'left' }}>
                <th style={{ padding: '8px' }}>Descripción</th>
                <th style={{ padding: '8px', width: '80px', textAlign: 'center' }}>Cant.</th>
                <th style={{ padding: '8px', width: '100px', textAlign: 'right' }}>P. Compra</th>
                <th style={{ padding: '8px', width: '100px', textAlign: 'right' }}>P. Venta</th>
                <th style={{ padding: '8px', width: '120px', textAlign: 'right' }}>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {orden.repuestos.map((repuesto, index) => (
                <tr key={index} style={{ borderBottom: '1px solid var(--border-color)' }}>
                  <td style={{ padding: '8px' }}>
                    {repuesto.descripcion}
                    {repuesto.lugar_cotizacion && <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>Proveedor: {repuesto.lugar_cotizacion}</div>}
                    {repuesto.notas && <div style={{ fontSize: '12px', color: 'var(--text-light)' }}>{repuesto.notas}</div>}
                  </td>
                  <td style={{ padding: '8px', textAlign: 'center' }}>{parseFloat(repuesto.cantidad).toFixed(2)}</td>
                  <td style={{ padding: '8px', textAlign: 'right', fontSize: '12px', color: 'var(--text-light)' }}>{formatMoney(repuesto.precio_compra)}</td>
                  <td style={{ padding: '8px', textAlign: 'right' }}>{formatMoney(repuesto.precio_venta)}</td>
                  <td style={{ padding: '8px', textAlign: 'right', fontWeight: '600' }}>{formatMoney(repuesto.subtotal_venta)}</td>
                </tr>
              ))}
              <tr>
                <td colSpan="2" style={{ padding: '8px', textAlign: 'right', fontSize: '12px', color: 'var(--text-light)' }}>
                  Costo Total Compra: {formatMoney(orden.repuestos.reduce((sum, r) => sum + parseFloat(r.subtotal_compra || 0), 0))}
                </td>
                <td colSpan="2" style={{ padding: '8px', textAlign: 'right', fontWeight: '600' }}>Total Repuestos (Venta):</td>
                <td style={{ padding: '8px', textAlign: 'right', fontWeight: '600', fontSize: '16px' }}>
                  {formatMoney(orden.repuestos.reduce((sum, r) => sum + parseFloat(r.subtotal_venta || 0), 0))}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Versión para imprimir - 2 boletas de media carta */}
      <div ref={printRef} style={{ display: 'none' }}>
        <style>
          {`
            @media print {
              @page {
                size: letter;
                margin: 0.3in;
              }
              body {
                font-family: Arial, sans-serif;
                font-size: 10px;
                margin: 0;
                padding: 0;
              }
              .boletas-container {
                width: 100%;
                height: 100vh;
                display: flex;
                flex-direction: column;
              }
              .boleta-recepcion {
                height: 50%;
                box-sizing: border-box;
                padding: 8px;
                border-bottom: 1px dashed #999;
                page-break-inside: avoid;
              }
              .boleta-recepcion:last-child {
                border-bottom: none;
              }
              .boleta-header {
                display: flex;
                align-items: flex-start;
                margin-bottom: 8px;
                border-bottom: 2px solid #1a365d;
                padding-bottom: 6px;
              }
              .boleta-order-number {
                border: 2px solid #f57c00;
                padding: 4px 10px;
                text-align: center;
                min-width: 100px;
              }
              .boleta-order-number small {
                font-size: 7px;
                display: block;
                color: #666;
              }
              .boleta-order-number span {
                color: #f57c00;
                font-size: 14px;
                font-weight: bold;
              }
              .boleta-empresa {
                flex: 1;
                text-align: center;
                padding: 0 10px;
              }
              .boleta-empresa h1 {
                color: #1a365d;
                font-size: 13px;
                margin: 0 0 2px 0;
              }
              .boleta-depto {
                font-weight: bold;
                font-size: 9px;
                margin: 2px 0;
              }
              .boleta-empresa p {
                margin: 1px 0;
                font-size: 8px;
              }
              .boleta-copia {
                font-size: 8px;
                font-weight: bold;
                color: #666;
                text-align: right;
                min-width: 70px;
              }
              .boleta-fecha {
                margin-bottom: 6px;
                font-size: 10px;
              }
              .boleta-cliente, .boleta-equipo, .boleta-observaciones {
                margin-bottom: 4px;
              }
              .boleta-row {
                display: flex;
                border-bottom: 1px dotted #ccc;
                padding: 2px 0;
                flex-wrap: wrap;
              }
              .boleta-label {
                font-weight: bold;
                width: 70px;
                flex-shrink: 0;
                font-size: 9px;
              }
              .boleta-value {
                flex: 1;
                min-width: 100px;
                font-size: 9px;
              }
              .boleta-falla {
                flex-basis: 100%;
                margin-left: 70px;
              }
              .boleta-firmas {
                display: flex;
                justify-content: space-between;
                margin-top: 10px;
                gap: 8px;
              }
              .boleta-firma-box {
                border: 1px solid #000;
                padding: 4px 6px;
                text-align: center;
                flex: 1;
              }
              .boleta-firma-cliente {
                flex: 1.2;
              }
              .boleta-firma-label {
                font-weight: bold;
                font-size: 8px;
                margin-bottom: 2px;
              }
              .boleta-firma-value {
                font-size: 9px;
                min-height: 18px;
              }
              .boleta-anticipo {
                font-weight: bold;
                color: #f57c00;
                font-size: 11px !important;
              }
              .boleta-firma-linea {
                border-top: 1px solid #000;
                margin-top: 18px;
                height: 2px;
              }
              .boleta-footer {
                margin-top: 6px;
                font-size: 7px;
                text-align: justify;
                line-height: 1.2;
                padding-top: 4px;
                border-top: 1px solid #ccc;
              }
              .boleta-footer p {
                margin: 0;
              }
            }
          `}
        </style>
        <div className="boletas-container">
          {/* Copia para el Cliente */}
          <BoletaRecepcion copia="COPIA CLIENTE" />

          {/* Copia para el Taller */}
          <BoletaRecepcion copia="COPIA TALLER" />
        </div>
      </div>

      {/* Versión para imprimir - Ticket 80mm */}
      <div ref={printTicketRef} style={{ display: 'none' }}>
        <style>
          {`
            /* ========================================
               CSS OPTIMIZADO PARA IMPRESORA TÉRMICA
               POS-80 / 80mm Thermal Printer
               ======================================== */

            @media print {
              @page {
                size: 72mm auto;
                margin: 0 !important;
                padding: 0 !important;
              }

              * {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
                color-adjust: exact !important;
              }

              body {
                /* Fuente Sans-Serif robusta para mejor contraste */
                font-family: Arial, Helvetica, 'Liberation Sans', sans-serif !important;
                font-size: 12px !important;
                font-weight: 600 !important;
                line-height: 1.3 !important;
                margin: 0 !important;
                padding: 0 !important;
                width: 72mm !important;
                max-width: 72mm !important;
                /* Color negro puro */
                color: #000 !important;
                background: #fff !important;
                /* Falsa negrita con text-shadow para engrosar texto */
                text-shadow: 0.3px 0 0 #000, -0.3px 0 0 #000 !important;
              }

              .ticket-container {
                width: 72mm !important;
                max-width: 72mm !important;
                padding: 2mm !important;
                box-sizing: border-box !important;
              }

              .ticket-header {
                text-align: center;
                border-bottom: 2px solid #000;
                padding-bottom: 3mm;
                margin-bottom: 3mm;
              }

              .ticket-logo {
                font-size: 18px !important;
                font-weight: 900 !important;
                margin-bottom: 2px;
                letter-spacing: 1px;
                text-shadow: 0.5px 0 0 #000, -0.5px 0 0 #000, 0 0.5px 0 #000 !important;
              }

              .ticket-subtitle {
                font-size: 12px !important;
                font-weight: 700 !important;
                margin-bottom: 2px;
                text-shadow: 0.3px 0 0 #000 !important;
              }

              .ticket-contact {
                font-size: 11px !important;
                font-weight: 600 !important;
              }

              .ticket-orden {
                text-align: center;
                font-size: 18px !important;
                font-weight: 900 !important;
                border: 2px solid #000;
                padding: 3mm;
                margin: 3mm 0;
                text-shadow: 0.5px 0 0 #000, -0.5px 0 0 #000 !important;
              }

              .ticket-fecha {
                text-align: center;
                font-size: 12px !important;
                font-weight: 600 !important;
                margin-bottom: 3mm;
              }

              .ticket-section {
                margin-bottom: 3mm;
              }

              .ticket-section-title {
                font-weight: 800 !important;
                font-size: 12px !important;
                border-bottom: 1px solid #000;
                margin-bottom: 2mm;
                padding-bottom: 1mm;
                text-shadow: 0.4px 0 0 #000 !important;
              }

              .ticket-row {
                display: flex;
                font-size: 11px !important;
                font-weight: 600 !important;
                margin-bottom: 1mm;
                line-height: 1.4;
              }

              .ticket-label {
                width: 22mm;
                font-weight: 800 !important;
                text-shadow: 0.3px 0 0 #000 !important;
              }

              .ticket-value {
                flex: 1;
                font-weight: 600 !important;
              }

              .ticket-falla {
                font-size: 11px !important;
                font-weight: 600 !important;
                margin-top: 2mm;
                padding: 2mm;
                border: 1px solid #000;
                background: transparent !important;
              }

              .ticket-falla strong {
                font-weight: 800 !important;
              }

              .ticket-totales {
                border-top: 2px solid #000;
                border-bottom: 2px solid #000;
                padding: 3mm 0;
                margin: 3mm 0;
              }

              .ticket-total-row {
                display: flex;
                justify-content: space-between;
                font-size: 12px !important;
                font-weight: 600 !important;
                margin-bottom: 1mm;
              }

              .ticket-total-row.grande {
                font-size: 14px !important;
                font-weight: 900 !important;
                margin-top: 2mm;
                text-shadow: 0.5px 0 0 #000, -0.5px 0 0 #000 !important;
              }

              .ticket-firmas {
                display: flex;
                justify-content: space-between;
                margin-top: 8mm;
                padding-top: 3mm;
              }

              .ticket-firma {
                text-align: center;
                width: 32mm;
              }

              .ticket-firma-linea {
                border-top: 1px solid #000;
                margin-bottom: 2mm;
                margin-top: 10mm;
              }

              .ticket-firma-label {
                font-size: 10px !important;
                font-weight: 700 !important;
              }

              .ticket-footer {
                margin-top: 4mm;
                padding-top: 3mm;
                border-top: 2px dashed #000;
                font-size: 10px !important;
                font-weight: 600 !important;
                text-align: center;
                line-height: 1.4;
              }

              .ticket-footer p {
                margin: 1mm 0 !important;
              }

              .ticket-corte {
                text-align: center;
                margin-top: 5mm;
                padding-top: 3mm;
                border-top: 2px dashed #000;
                font-size: 10px !important;
                font-weight: 700 !important;
              }
            }
          `}
        </style>
        <div className="ticket-container">
          <div className="ticket-header">
            <div className="ticket-logo">INTERSECOM</div>
            <div className="ticket-subtitle">DE TODO EN COMPUTACION</div>
            <div className="ticket-subtitle">- DEPTO. TECNICO -</div>
            <div className="ticket-contact">15 Av. 1-340 Zona 5, San Marcos</div>
            <div className="ticket-contact">Tel: 7760-3991 / 7725-4830</div>
          </div>

          <div className="ticket-orden">
            ORDEN N° {orden.numero_orden}
          </div>

          <div className="ticket-fecha">
            Fecha: {formatDate(orden.fecha_recepcion)}
          </div>

          <div className="ticket-section">
            <div className="ticket-section-title">CLIENTE</div>
            <div className="ticket-row">
              <span className="ticket-label">Nombre:</span>
              <span className="ticket-value">{orden.nombre_cliente}</span>
            </div>
            <div className="ticket-row">
              <span className="ticket-label">Telefono:</span>
              <span className="ticket-value">{orden.telefono_cliente || '-'}</span>
            </div>
          </div>

          {orden.equipo1_descripcion && (
            <div className="ticket-section">
              <div className="ticket-section-title">EQUIPO 1</div>
              <div className="ticket-row">
                <span className="ticket-label">Desc:</span>
                <span className="ticket-value">{orden.equipo1_descripcion}</span>
              </div>
              {orden.equipo1_marca && (
                <div className="ticket-row">
                  <span className="ticket-label">Marca:</span>
                  <span className="ticket-value">{orden.equipo1_marca}</span>
                </div>
              )}
              {orden.equipo1_numero_serie && (
                <div className="ticket-row">
                  <span className="ticket-label">Serie:</span>
                  <span className="ticket-value">{orden.equipo1_numero_serie}</span>
                </div>
              )}
              {orden.equipo1_accesorios && (
                <div className="ticket-row">
                  <span className="ticket-label">Acces:</span>
                  <span className="ticket-value">{orden.equipo1_accesorios}</span>
                </div>
              )}
              <div className="ticket-falla">
                <strong>Falla:</strong> {orden.equipo1_falla || '-'}
              </div>
            </div>
          )}

          {orden.equipo2_descripcion && (
            <div className="ticket-section">
              <div className="ticket-section-title">EQUIPO 2</div>
              <div className="ticket-row">
                <span className="ticket-label">Desc:</span>
                <span className="ticket-value">{orden.equipo2_descripcion}</span>
              </div>
              {orden.equipo2_marca && (
                <div className="ticket-row">
                  <span className="ticket-label">Marca:</span>
                  <span className="ticket-value">{orden.equipo2_marca}</span>
                </div>
              )}
              <div className="ticket-falla">
                <strong>Falla:</strong> {orden.equipo2_falla || '-'}
              </div>
            </div>
          )}

          {orden.equipo3_descripcion && (
            <div className="ticket-section">
              <div className="ticket-section-title">EQUIPO 3</div>
              <div className="ticket-row">
                <span className="ticket-label">Desc:</span>
                <span className="ticket-value">{orden.equipo3_descripcion}</span>
              </div>
              <div className="ticket-falla">
                <strong>Falla:</strong> {orden.equipo3_falla || '-'}
              </div>
            </div>
          )}

          {orden.observaciones && (
            <div className="ticket-section">
              <div className="ticket-section-title">OBSERVACIONES</div>
              <div style={{ fontSize: '8px' }}>{orden.observaciones}</div>
            </div>
          )}

          <div className="ticket-totales">
            <div className="ticket-total-row">
              <span>Mercaderia:</span>
              <span>{formatMoney(orden.precio_mercaderia)}</span>
            </div>
            <div className="ticket-total-row">
              <span>Trabajo:</span>
              <span>{formatMoney(orden.costo_trabajo)}</span>
            </div>
            <div className="ticket-total-row grande">
              <span>TOTAL:</span>
              <span>{formatMoney(orden.valor_total)}</span>
            </div>
            <div className="ticket-total-row">
              <span>Anticipo:</span>
              <span>-{formatMoney(orden.anticipo)}</span>
            </div>
            <div className="ticket-total-row grande">
              <span>SALDO:</span>
              <span>{formatMoney(orden.saldo)}</span>
            </div>
          </div>

          <div className="ticket-row">
            <span className="ticket-label">Recibido:</span>
            <span className="ticket-value">{orden.nombre_tecnico || '-'}</span>
          </div>
          {orden.nombre_tecnico_asignado && (
            <div className="ticket-row">
              <span className="ticket-label">Tecnico:</span>
              <span className="ticket-value" style={{ fontWeight: '800' }}>{orden.nombre_tecnico_asignado}</span>
            </div>
          )}
          <div className="ticket-row">
            <span className="ticket-label">Tienda:</span>
            <span className="ticket-value">{orden.nombre_tienda || '-'}</span>
          </div>

          {orden.status === 'entregada' && parseFloat(orden.saldo) === 0 && (
            <div style={{
              marginTop: '3mm',
              padding: '2mm',
              border: '2px solid #000',
              textAlign: 'center'
            }}>
              <div style={{ fontWeight: '900', fontSize: '12px' }}>✓ PAGADO COMPLETO</div>
              <div style={{ fontSize: '10px', marginTop: '1mm' }}>
                {orden.tipo_pago}
                {orden.monto_pago_final && ` - ${formatMoney(orden.monto_pago_final)}`}
              </div>
              {orden.referencia_pago && (
                <div style={{ fontSize: '9px' }}>Ref: {orden.referencia_pago}</div>
              )}
              {orden.fecha_pago_final && (
                <div style={{ fontSize: '9px' }}>Fecha: {formatDate(orden.fecha_pago_final)}</div>
              )}
            </div>
          )}

          <div className="ticket-firmas">
            <div className="ticket-firma">
              <div className="ticket-firma-linea"></div>
              <div className="ticket-firma-label">ENTREGUE CONFORME</div>
            </div>
            <div className="ticket-firma">
              <div className="ticket-firma-linea"></div>
              <div className="ticket-firma-label">RECIBI CONFORME</div>
            </div>
          </div>

          <div className="ticket-footer">
            <p>No nos hacemos responsables por</p>
            <p>equipos no recogidos en 30 dias.</p>
            <p>Garantia no cubre mal uso o</p>
            <p>problemas de corriente electrica.</p>
          </div>

          <div className="ticket-corte">
            - - - - - - - - - - - - - - - - - - -
          </div>
        </div>
      </div>

      {/* Historial de Cambios */}
      {orden.historial && orden.historial.length > 0 && (
        <div className="card">
          <h3 className="card-title" style={{ marginBottom: '16px' }}>Historial de Cambios</h3>
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Campo</th>
                  <th>Valor Anterior</th>
                  <th>Valor Nuevo</th>
                  <th>Realizado Por</th>
                </tr>
              </thead>
              <tbody>
                {orden.historial.map((h) => (
                  <tr key={h.id}>
                    <td style={{ whiteSpace: 'nowrap' }}>{formatDateTime(h.created_at)}</td>
                    <td style={{ fontWeight: 500 }}>{h.campo}</td>
                    <td>{h.valor_anterior || '-'}</td>
                    <td>{h.valor_nuevo || '-'}</td>
                    <td>{h.empleado_nombre || 'Sistema'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Modal de Entrega */}
      {showEntregaModal && (
        <div className="modal-overlay" onClick={() => setShowEntregaModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '500px' }}>
            <div className="modal-header">
              <h2>Entregar Orden #{orden.numero_orden}</h2>
              <button className="modal-close" onClick={() => setShowEntregaModal(false)}>&times;</button>
            </div>
            <form onSubmit={handleEntrega}>
              <div className="modal-body">
                <div style={{ background: '#f0f9ff', padding: '16px', borderRadius: '8px', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                    <span>Total de la orden:</span>
                    <strong>{formatMoney(orden.valor_total)}</strong>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                    <span>Anticipo pagado:</span>
                    <span>- {formatMoney(orden.anticipo)}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '8px', borderTop: '1px solid #bee3f8' }}>
                    <strong>Saldo pendiente:</strong>
                    <strong style={{ color: '#e53e3e', fontSize: '18px' }}>{formatMoney(orden.saldo)}</strong>
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label required">Tipo de Pago</label>
                  <select
                    className="form-input"
                    value={entregaForm.tipo_pago}
                    onChange={(e) => setEntregaForm({ ...entregaForm, tipo_pago: e.target.value, referencia_pago: '' })}
                    required
                  >
                    <option value="Efectivo">Efectivo</option>
                    <option value="Transferencia">Transferencia Bancaria</option>
                    <option value="Tarjeta">Tarjeta de Crédito/Débito</option>
                    <option value="Cheque">Cheque</option>
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label required">Monto Pagado</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    className="form-input"
                    value={entregaForm.monto_pago}
                    onChange={(e) => setEntregaForm({ ...entregaForm, monto_pago: e.target.value })}
                    required
                  />
                </div>

                {entregaForm.tipo_pago === 'Transferencia' && (
                  <div className="form-group">
                    <label className="form-label required">Número de Transferencia</label>
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Ej: 123456789"
                      value={entregaForm.referencia_pago}
                      onChange={(e) => setEntregaForm({ ...entregaForm, referencia_pago: e.target.value })}
                      required
                    />
                  </div>
                )}

                {entregaForm.tipo_pago === 'Tarjeta' && (
                  <div className="form-group">
                    <label className="form-label required">Número de Transacción</label>
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Ej: AUTH-123456"
                      value={entregaForm.referencia_pago}
                      onChange={(e) => setEntregaForm({ ...entregaForm, referencia_pago: e.target.value })}
                      required
                    />
                  </div>
                )}

                {entregaForm.tipo_pago === 'Cheque' && (
                  <div className="form-group">
                    <label className="form-label required">No. Cheque / Referencia / Banco</label>
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Ej: CHQ-987654 Banrural"
                      value={entregaForm.referencia_pago}
                      onChange={(e) => setEntregaForm({ ...entregaForm, referencia_pago: e.target.value })}
                      required
                    />
                  </div>
                )}

                <div className="form-group">
                  <label className="form-label">Notas de Entrega</label>
                  <textarea
                    className="form-input"
                    rows="2"
                    placeholder="Observaciones adicionales..."
                    value={entregaForm.notas_entrega}
                    onChange={(e) => setEntregaForm({ ...entregaForm, notas_entrega: e.target.value })}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowEntregaModal(false)}>
                  Cancelar
                </button>
                <button type="submit" className="btn btn-success" disabled={entregando} style={{ background: '#38a169' }}>
                  {entregando ? 'Procesando...' : 'Confirmar Entrega'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrdenDetalle;
